import React, { useState } from 'react';
import { ReactComponent as Sun } from '../../assets/Sun.svg';
import { ReactComponent as Moon } from '../../assets/Moon.svg';
import logo from '../../assets/logo.png';
import './Header.css';

const Header = () => {
        // TOGGLE MENU
    const[Toggle, showMenu] = useState(false);

    // DARK MODE CONTROL
    const setDarkMode = () => {
        document.querySelector("body").setAttribute('data__theme', 'dark');
        localStorage.setItem('selectedTheme', "dark")
    }
    const setLightMode = () => {
        document.querySelector("body").setAttribute('data__theme', 'light');
        localStorage.setItem('selectedTheme', "light")
    };

    const selectedTheme = localStorage.getItem("selectedTheme");

    if(selectedTheme === 'dark') {
        setDarkMode();
    }

    const toggleTheme = (e) => {
        if(e.target.checked) setDarkMode();
        else setLightMode()
    };

  return (
    <header className='header'>
        <nav className="nav container navbar navbar-default navbar-fixed-top" aria-label="Main navigation">
            <a href="index.html" className="nav__logo" aria-label="Home"> 
            <img src={logo} alt="Mokom Collins logo" className='nav__logo-img' />
            Mokom <span style={{ color: '#3366ff', }}>Collins</span>
            </a>
            <div className={Toggle ? "nav__menu show-menu" : "nav__menu"}>
                <ul className="nav__list grid" role="menubar">
                    <li className="nav_item" role="none">
                    <a href="#home" className="nav__link active-link" role="menuitem" aria-label="Navigate to home section">
                        <i className="uil uil-estate nav__icon" aria-hidden="true"></i>Home
                    </a>
                    </li>
                    <li className="nav_item" role="none">
                    <a href="#about" className="nav__link" role="menuitem" aria-label="Navigate to about section">
                        <i className="uil uil-user nav__icon" aria-hidden="true"></i>About
                    </a>
                    </li>
                    <li className="nav_item" role="none">
                    <a href="#skills" className="nav__link" role="menuitem" aria-label="Navigate to skills section">
                        <i className="uil uil-file-alt nav__icon" aria-hidden="true"></i>Skills
                    </a>
                    </li>
                    <li className="nav_item" role="none">
                    <a href="#portfolio" className="nav__link" role="menuitem" aria-label="Navigate to portfolio section">
                        <i className="uil uil-scenery nav__icon" aria-hidden="true"></i>Portfolio
                    </a>
                    </li>
                    <li className="nav_item" role="none">
                    <a href="#contact" className="nav__link" role="menuitem" aria-label="Navigate to contact section">
                        <i className="uil uil-message nav__icon" aria-hidden="true"></i>Contact
                    </a>
                    </li>
                    <div className="dark__mode float">
                            <input type="checkbox" 
                            className="dark__mode-input" 
                            id='dark__mode-toggle' 
                            onChange={toggleTheme}
                            defaultChecked={selectedTheme === 'dark'}
                            aria-label="Toggle dark mode"
                            />
                            <label className="dark__mode-label" htmlFor='dark__mode-toggle' aria-label="Theme toggle button">
                                <Sun aria-hidden="true"/>
                                <Moon aria-hidden="true"/>
                            </label>
                </div>
                </ul>
                
                <i className="uil uil-times nav__close" onClick={()=> showMenu(!Toggle)} role="button" aria-label="Close menu" tabIndex={0} onKeyPress={(e) => e.key === 'Enter' && showMenu(!Toggle)}></i>
            </div>
            <div className="nav__toggle" onClick={()=>  showMenu(!Toggle)} role="button" aria-label="Open menu" tabIndex={0} onKeyPress={(e) => e.key === 'Enter' && showMenu(!Toggle)}>
                <i className="uil uil-apps" aria-hidden="true"></i>
            </div>
            
        </nav>
    </header>
  )
}

export default Header